import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useConnectedAction } from 'src/hooks/use-connected-action';
import { sessionRecordingService } from 'src/services/sessionRecordingService';
import { openDialog } from 'src/store/dialog/actions';
import { EnumDialogsKeys } from 'src/store/dialog/types';
import gitVersion from 'src/_git_commit';
import _styles from './styles.module.scss';
import { useTabFocus } from './useTabFocus';

const gitInfo = (gitVersion as any)?.logMessage ?? null;

export const versionString = gitInfo;

const Version: FC = () => {
  const _openDialog = useConnectedAction(openDialog);
  const { t }: Translation = useTranslation();

  const checkVersion = (version: string | null): void => {
    if (gitInfo && version) {
      if (gitInfo !== version) {
        const affiliateParams = sessionStorage.getItem('affiliateParams');

        localStorage.clear();
        sessionStorage.clear();

        if (affiliateParams) {
          window.location.reload();
          sessionStorage.setItem('affiliateParams', affiliateParams);
        } else {
          window.location.replace('/');
        }
      }
      sessionRecordingService.trackEvent('App version updated');
    } else if (!version) {
      localStorage.setItem('app_version', gitInfo);
    }
  };

  const checkStoredVersion = (): void => {
    const storedVersion = localStorage.getItem('app_version');
    checkVersion(storedVersion);
  };

  const checkRemoteVersion = async (): Promise<void> => {
    fetch('/version.json', { cache: 'no-store' }).then((res) => {
      res.json().then((data) => {
        if (data?.logMessage && data.logMessage !== gitInfo) {
          _openDialog({
            dialogType: EnumDialogsKeys.VERSION_UPDATE,
            dialogProps: {
              data: {
                newVersion: data.logMessage,
                currentVersion: versionString,
                onConfirm: checkVersion,
              },
            },
          });
        }
      });
    });
  };

  useEffect(() => {
    checkStoredVersion();
  }, []);

  useTabFocus({ onFocus: checkRemoteVersion });

  if (gitInfo) {
    return (
      <p className={_styles.version}>
        {t('version')}: {gitInfo}
      </p>
    );
  }

  return null;
};
export default Version;
